import { createServiceError, getServiceErrorMessage } from '../utils/serverErrorFormatter';
export default (function (lang) {
  return function (error, i18nChunkPath) {
    return getServiceErrorMessage(lang, createServiceError(error), i18nChunkPath);
  };
});